import { Card, CardBody, HStack, Icon, Stack, Text } from '@chakra-ui/react';
import { IdentificationIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

import { UboInfosFragment } from '@blockpulse3/graphql/hooks';
import { formatCountry, formatDate } from '@blockpulse3/helpers';

type Props = {
  ubo: UboInfosFragment;
  index: number;
};

export function UltimateBeneficialOwnerCard({ ubo, index }: Props): JSX.Element {
  const i18nShareholderStatus = useTranslations('ShareholderStatusValues');
  const i18nUltimateBeneficialOwnerCard = useTranslations('UltimateBeneficialOwnerCard');

  return (
    <Card key={ubo.id}>
      <CardBody>
        <HStack pb="2">
          <Icon
            as={IdentificationIcon}
            bgColor="gray.50"
            border="1px"
            borderColor="gray.200"
            boxSize="24px"
          />
          <Text fontSize="lg" fontWeight="600">
            {i18nUltimateBeneficialOwnerCard('CardTitle', {
              index: index + 1,
            })}
          </Text>
        </HStack>
        <Stack>
          <Stack pb="2" spacing="0">
            <Text fontWeight="500">{`${ubo.firstName} ${ubo.lastName}`}</Text>
            {ubo?.individualIdentity?.email && (
              <Text color="gray.600">{ubo.individualIdentity.email}</Text>
            )}
          </Stack>
          <HStack justify="space-between">
            <Text color="gray.600">{i18nUltimateBeneficialOwnerCard('Birthdate')}</Text>
            <Text fontWeight="500">{formatDate(ubo.birthdate)}</Text>
          </HStack>
          <HStack justify="space-between">
            <Text color="gray.600">{i18nUltimateBeneficialOwnerCard('Birthplace')}</Text>
            <Text fontWeight="500">{ubo.birthplace}</Text>
          </HStack>
          <HStack justify="space-between">
            <Text color="gray.600">{i18nUltimateBeneficialOwnerCard('Country')}</Text>
            <Text fontWeight="500">{formatCountry(ubo.birthCountry)}</Text>
          </HStack>
          <HStack justify="space-between">
            <Text color="gray.600">{i18nUltimateBeneficialOwnerCard('ZipCode')}</Text>
            <Text fontWeight="500">{ubo.birthCityPostalCode}</Text>
          </HStack>
          <HStack justify="space-between">
            <Text color="gray.600">{'Statut'}</Text>
            <Text fontWeight="500">
              {i18nShareholderStatus(ubo.role as keyof IntlMessages['ShareholderStatusValues'])}
            </Text>
          </HStack>
          <HStack justify="space-between">
            <Text color="gray.600">{i18nUltimateBeneficialOwnerCard('Percentage')}</Text>
            <Text fontWeight="500">{`${ubo.sharePercentage}%`}</Text>
          </HStack>
          {ubo.isDirect && (
            <HStack justify="space-between">
              <Text>{i18nUltimateBeneficialOwnerCard('IsDirect')}</Text>
            </HStack>
          )}
        </Stack>
      </CardBody>
    </Card>
  );
}
